import React, { useCallback, useEffect, useState } from 'react';
import PageMaintenance from '../pages/PageMaintenance';

/**
 * Écoute l'intercepteur et affiche l'écran de maintenance.
 *
 * POURQUOI UN ÉVÉNEMENT. L'intercepteur d'`axiosInstance` vit hors de React : il
 * ne peut appeler aucun `setState`. Le dépôt utilise déjà `CustomEvent` préfixé
 * `cb:` pour ce genre de pont (compteurs de la SideBar, changement d'onglet) ;
 * on suit la même convention plutôt que d'introduire un magasin d'état pour un
 * seul booléen.
 *
 * « RÉESSAYER » RECHARGE LA PAGE, ET C'EST VOULU. Se contenter de masquer l'écran
 * laisserait une application dont les appels ont tous échoué : des listes vides,
 * des compteurs à zéro, un état partiel que rien ne viendrait corriger. Le
 * rechargement repart d'un état propre, et la session est conservée puisqu'on ne
 * touche pas au jeton.
 */
export default function GardeMaintenance() {
  const [indisponible, setIndisponible] = useState(false);

  useEffect(() => {
    const surPanne = () => setIndisponible(true);
    window.addEventListener('cb:service-indisponible', surPanne);
    return () => window.removeEventListener('cb:service-indisponible', surPanne);
  }, []);

  const reessayer = useCallback(() => window.location.reload(), []);

  if (!indisponible) return null;
  return <PageMaintenance onReessayer={reessayer} />;
}
